var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.059 8.378c-.83-.793-1.884-1.196-3.058-1.196-2.084 0-3.848 1.407-4.477 3.298A4.81 4.81 0 0 0 7.273 12c0 .527.09 1.04.25 1.52.63 1.89 2.394 3.298 4.478 3.298 1.076 0 1.992-.283 2.708-.763a3.68 3.68 0 0 0 1.596-2.415H12v-3.095h7.535c.094.524.145 1.07.145 1.637 0 2.436-.873 4.487-2.385 5.88C15.97 19.282 14.16 20 12 20A7.997 7.997 0 0 1 4 12a7.997 7.997 0 0 1 8-8c2.157 0 3.968.793 5.353 2.084L15.06 8.378Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.886 8.559.177.169.173-.173L17.53 6.26l.183-.183-.19-.176c-1.43-1.333-3.3-2.151-5.522-2.151a8.247 8.247 0 0 0-7.373 11.955 8.247 8.247 0 0 0 7.373 4.545c2.217 0 4.09-.737 5.463-2.005 1.57-1.445 2.466-3.566 2.466-6.063a9.44 9.44 0 0 0-.15-1.681l-.037-.206H11.75v3.595h4.242a3.43 3.43 0 0 1-1.422 1.957c-.671.45-1.538.721-2.57.721-1.967 0-3.641-1.33-4.24-3.127A4.559 4.559 0 0 1 7.524 12c0-.498.086-.984.238-1.44v-.001c.598-1.797 2.272-3.127 4.24-3.127 1.114 0 2.105.381 2.885 1.127Z",
    stroke: "#000",
    strokeOpacity: 0.16,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.68 12.182c0-.568-.05-1.113-.145-1.637H12v3.095h4.305a3.68 3.68 0 0 1-1.596 2.415v2.007h2.585c1.513-1.393 2.386-3.444 2.386-5.88Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20c2.16 0 3.972-.716 5.295-1.938l-2.585-2.008c-.717.48-1.633.764-2.71.764-2.083 0-3.847-1.407-4.476-3.298H4.852v2.073A7.997 7.997 0 0 0 12 20Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.524 13.52c-.16-.48-.251-.993-.251-1.52s.09-1.04.25-1.52V8.407H4.852A7.997 7.997 0 0 0 4 12c0 1.29.31 2.513.85 3.593l2.674-2.073Z",
    fill: "#FBBC05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.182c1.175 0 2.23.403 3.059 1.196l2.294-2.294C15.968 4.793 14.157 4 12.001 4a7.997 7.997 0 0 0-7.15 4.407l2.673 2.073c.63-1.89 2.393-3.298 4.477-3.298Z",
    fill: "#EA4335"
  })));
};
export default SvgGoogle;